module.exports = __webpack_public_path__ + "img/Bar.21d6ddf8.jpg";